import { UsersListItem } from "../model/users/users-list";
import API from "../utility/axios";
const apiUrl = '/api/v2';

export const GET_INSTITUTE_DASHBOARD = (data:String): Promise<UsersListItem[]> => {
    return API.get(`${apiUrl}/dashboard/stats?institute_code=${data}`);
}